import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["kind", "shape", "intent", "small", "grouped", "disabled", "active", "loading", "slot", "className", "children"];
/* eslint-disable react/prop-types */

/**
 * Button base component
 *
 * Returns a react-router `Link` component if the prop `to` is provided.
 * Returns an `a` element if the prop `href` is provided.
 * Else returns a `button` element.
 *
 * Add the `type` property only if defined.
 * Keeps the <button> element default behavior: `submit`.
 *
 * For native HTML element properties
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button
 *
 * A11y
 * For the `loading` state we hide the label with the `visibility` property,
 * this should make screenreaders aware of content change in the button so
 * they can announce the spinner text. `aria-busy` and other props mix are
 * know to be buggy accross screenreaders.
 *
 * 
 */

import * as React from 'react';
import clsx from 'clsx';
import Spinner from '../Spinner';
import { Interactive, Base } from '../Base';
var styles = {
  "root": "ButtonBase-root_r3xHh",
  "slot": "ButtonBase-slot_Csw1g",
  "spinner": "ButtonBase-spinner_Do7SO",
  "shapeDefault": "ButtonBase-shapeDefault_21OT6",
  "shapeCompact": "ButtonBase-shapeCompact_20BTQ",
  "shapeCircle": "ButtonBase-shapeCircle_3o4hl",
  "kindDefault": "ButtonBase-kindDefault_vBGtr",
  "active": "ButtonBase-active_1tBZd",
  "kindOutline": "ButtonBase-kindOutline_2X76w",
  "kindGhost": "ButtonBase-kindGhost_3Owv3",
  "kindLink": "ButtonBase-kindLink_1V-tS",
  "intentDefault": "ButtonBase-intentDefault_3rcno",
  "intentSuccess": "ButtonBase-intentSuccess_2na6u",
  "intentDanger": "ButtonBase-intentDanger_1ot21",
  "heightDefault": "ButtonBase-heightDefault_1Turh",
  "heightSmall": "ButtonBase-heightSmall_323-Y",
  "widthDefault": "ButtonBase-widthDefault_YOV2r",
  "widthSmall": "ButtonBase-widthSmall_2nBCE",
  "grouped": "ButtonBase-grouped_1w1JZ",
  "disabled": "ButtonBase-disabled_2gmTj",
  "loading": "ButtonBase-loading_3DNnc"
};
function ButtonBase(_ref, ref) {
  var _clsx;
  var _ref$kind = _ref.kind,
    kind = _ref$kind === void 0 ? 'default' : _ref$kind,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'default' : _ref$shape,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'default' : _ref$intent,
    small = _ref.small,
    grouped = _ref.grouped,
    disabled = _ref.disabled,
    active = _ref.active,
    loading = _ref.loading,
    slotProp = _ref.slot,
    className = _ref.className,
    children = _ref.children,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var rootClasses = clsx(styles.root, (_clsx = {}, _defineProperty(_clsx, styles.kindDefault, kind === 'default'), _defineProperty(_clsx, styles.kindOutline, kind === 'outline'), _defineProperty(_clsx, styles.kindGhost, kind === 'ghost'), _defineProperty(_clsx, styles.kindLink, kind === 'link'), _defineProperty(_clsx, styles.shapeDefault, kind !== 'link' && shape === 'default'), _defineProperty(_clsx, styles.shapeCompact, kind !== 'link' && shape === 'compact'), _defineProperty(_clsx, styles.shapeCircle, kind !== 'link' && shape === 'circle'), _defineProperty(_clsx, styles.intentDefault, intent === 'default'), _defineProperty(_clsx, styles.intentSuccess, intent === 'success'), _defineProperty(_clsx, styles.intentDanger, intent === 'danger'), _defineProperty(_clsx, styles.heightDefault, kind !== 'link' && !small), _defineProperty(_clsx, styles.heightSmall, kind !== 'link' && small), _defineProperty(_clsx, styles.widthDefault, kind !== 'link' && !small && /compact|circle/.test(shape)), _defineProperty(_clsx, styles.widthSmall, kind !== 'link' && small && /compact|circle/.test(shape)), _defineProperty(_clsx, styles.grouped, grouped), _defineProperty(_clsx, styles.disabled, disabled), _defineProperty(_clsx, styles.active, active), _defineProperty(_clsx, styles.loading, loading), _clsx), className);
  var slot = loading ? /*#__PURE__*/React.createElement(Spinner, {
    name: "dots",
    theme: kind === 'default' ? 'dark' : 'light',
    className: styles.spinner
  }) : slotProp;
  var visibility = /*#__PURE__*/React.isValidElement(slot) ? 'hidden' : undefined;
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Interactive, _extends({
      flexInline: true,
      flexAlignItemsCenter: true,
      flexJustifyCenter: true,
      interactive: true,
      boxSizing: "border",
      position: "relative",
      disabled: disabled || loading,
      className: rootClasses,
      innerRef: ref
    }, extraProps), slot && /*#__PURE__*/React.createElement(Base, {
      tagName: "span",
      position: "absolute",
      className: styles.slot
    }, slot), /*#__PURE__*/React.isValidElement(children) && /*#__PURE__*/React.cloneElement(children, {
      visibility: visibility
    }))
  );
}
var Export = /*#__PURE__*/React.forwardRef(ButtonBase);
Export.displayName = 'ButtonBase';
export default Export;